module.exports = __webpack_public_path__ + "static/1141343601.908a7895.jpg";